import DataTile from "./DataTile";
import React, {useState} from "react";
import BBIconConstructionCone from "../../../assets/bbCustomIcons/BBIconConstructionCone";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbGetApplicableCloudIntegrationsOfTypeForEntity,
    bbIsCloudIntegrationTypeActiveForEntity,
    bbIsCloudIntegrationTypeActiveWithErrorsForEntity,
    bbShortenString, isCurrentUserMemberOf,
} from "../../../util/bbHelpers";
import Button from "@material-ui/core/Button";
import BBExternalLink from "../accents/BBExternalLink";
import {useDispatch, useSelector} from "react-redux";
import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContentText from "@material-ui/core/DialogContentText";
import BBIconUnlink from "../../../assets/bbCustomIcons/BBIconUnlink";
import {unregisterCloudIntegration} from "../../../actions";
import CloudIntegrationRegistrationForm from "../modals/CloudIntegrationRegistrationForm";

const Tile = (props) => {

    const {integrationOption, integrationObjects, portfolioView = false} = props;
    const {entityInView, selfEntityId} = useSelector(({breachrisk}) => breachrisk);

    const authUser = useSelector(({auth}) => auth.authUser);
    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const canAddIntegration = entityInView !==selfEntityId ? (isAdministratorForThisEntity || isStaffAdmin) : (isTrustedAgentForThisEntity || isStaffAdmin)
    const dispatch = useDispatch();

    const isActive = integrationOption && integrationOption.available
    const applicableIntegrations = bbGetApplicableCloudIntegrationsOfTypeForEntity(entityInView, integrationOption.id, integrationObjects);
    const integrationInView = applicableIntegrations ? applicableIntegrations[Object.keys(applicableIntegrations).pop()] : null;

    const readyButton =
        <Button
            variant={"contained"}
            className={"m-2"}
            color={"primary"}
            onClick={()=>handleDialogOpen()}
        >
            Integrate Now
        </Button>

    const comingSoonButton =
        <Button
            variant={"outlined"}
            disabled={true}
        >
            Coming Soon
        </Button>

    const colorFunction = (stateData) => {
        return !isActive && "inactive-gray";
    }

    const displayName = integrationOption ? integrationOption.name : "Cloud Integration"

    const integrationNameWithLink = integrationOption && integrationOption.documentation_url
        ? <BBExternalLink tipText={'Read more about how to make this integration at our knowledge base. (New tab)'} href={integrationOption ? integrationOption.documentation_url : null}>{displayName}</BBExternalLink>
        : displayName

    const integrationLogoImage =
        integrationOption
        && integrationOption.logo_url
            ? <img style={{height: 70}} className={"rounded bg-white p-1"} src={integrationOption.logo_url } alt={`${bbShortenString(integrationOption.description, 55, true)}`} />
            : <BBIconConstructionCone style={{fontSize: "70px"}}/>

    const valueFunction = (stateData) => {
        return <div>{dialog}{readyButton}</div>
    }


    //Registration Form
    const [open, setOpen] = useState(false);

    const handleDialogOpen = () =>{
        setOpen(true);
    }

    const handleDialogClose = () =>{
        setOpen(false);
    }

    const dialog = <div><Dialog open={open}
        // fullScreen
                              maxWidth={"xl"}
                              onClose={handleDialogClose}
                              aria-labelledby="form-dialog-title">
        <DialogTitle className="form-dialog-title mr-4 ml-4" id="customized-dialog-title" onClose={handleDialogClose}>
            <div className={"row"}>

                <div className={"col-6 p-0 m-0"}>

                </div>
                <div className={"col-11"}/>

                <div className={"col-1 text-right"}>

                    <IconButton
                        // variant={"s"}
                        // color={"lightest-gray"}
                        onClick={()=>handleDialogClose()}>
                        <CloseIcon/>
                    </IconButton>
                </div>
            </div>
            <div className={"row"}>

                <div className={"col-12 text-center"}>
                    <h1>Cloud Integration: {integrationOption.name}</h1>
                    <p>Use this form to integrate BreachRisk with {integrationOption.name}.</p>
                </div>
            </div>
        </DialogTitle>
        {canAddIntegration
            ?<DialogContent>
            <DialogContentText>
                <div className={"border-2 p-3 bg-lightest-gray"}>
                    <div className={"text-center m-1"}>
                        {integrationLogoImage}
                    </div>
                    <div style={{height: '90%'}}>

                        <CloudIntegrationRegistrationForm
                            integrationOption={integrationOption}
                            entityId={entityInView}
                            integrationObjects={integrationObjects}
                            integrationInView={integrationInView}
                        />

                    </div>
                </div>

            </DialogContentText>
        </DialogContent>
        :<DialogContent>
                <DialogContentText>
                    <div className={"border-2 p-3 bg-lightest-gray"}>
                        <div className={"text-center m-1"}>
                            {integrationLogoImage}
                        </div>
                        <div style={{height: '90%'}}>

                            <p>
                                Adding an integration requires Administrator or Manager level access for this company.
                            </p>
                        </div>
                    </div>

                </DialogContentText>
            </DialogContent>}

    </Dialog>
    </div>


    return (
        <DataTile
            color = {colorFunction()}
            colorBgFunction={colorFunction}
            subTitle= {integrationNameWithLink}
            tipText={`${isActive ? "" : "(Coming Soon): "} Integrate BreachRisk™ with ${integrationOption.name} to allow for automatic verifications, making your BreachRisk™ Score higher fidelity.`}
            icon={<div className="animated fadeIn animation-duration-3">{integrationLogoImage}</div>}
            dontFetch
            valueFunction={valueFunction}
            ribbonFunction={null}
        />
    )

}

export default Tile;